"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MlcTooltip_1 = __importDefault(require("@Components/MlcTooltip"));
const react_1 = __importDefault(require("react"));
require("./index.scss");
const MenuPopover = (props) => (react_1.default.createElement(MlcTooltip_1.default, { id: props.menuId, variant: "light", place: 'bottom', className: 'popover-wrapper', isOpen: props.isOpen, events: ['click'], clickable: true },
    react_1.default.createElement("div", { className: 'menu-popover' },
        react_1.default.createElement("div", { className: 'popover-content' }, props.children))));
exports.default = MenuPopover;
